import {
	Home3,
	Theme3SubtopicOneActivityOne,
	Theme3Introduction,
	Theme3SubtopicOneActivityTwo,
	Theme3SubtopicOneActivityThree,
	Theme3SubtopicOneActivityFour,
	Theme3SubtopicOneActivityFive,
	Theme3SubtopicOneFinalPoints,
	Theme3SubtopicTwoActivityOne,
	Theme3SubtopicTwoActivityTwo,
	Theme3SubtopicTwoActivityThree,
	Theme3SubtopicTwoActivityFour,
	Theme3SubtopicTwoActivityFive,
	Theme3SubtopicTwoFinalPoints,
	Theme3SubtopicThreeActivityOne,
	Theme3SubtopicThreeActivityTwo,
	Theme3SubtopicThreeActivityThree,
	Theme3SubtopicThreeActivityFour,
	Theme3SubtopicThreeFinalPoints,
	SubtopicFinalTeam3
} from "../pages/tema3";


export const pathTeam3 = {
	path: "home3",
	element: <Home3 />,
	children: [
		{
			path: "tema3",
			children: [
				{
					path: "introduction",
					element: <Theme3Introduction />,
				},
				{
					path: "subtema1",
					children: [
						{
							path: "activityOne",
							element: <Theme3SubtopicOneActivityOne />,
						},
						{
							path: "activityTwo",
							element: <Theme3SubtopicOneActivityTwo />,
						},
						{
							path: "activityThree",
							element: <Theme3SubtopicOneActivityThree />,
						},
						{
							path: "activityFour",
							element: <Theme3SubtopicOneActivityFour />,
						},
						{
							path: "activityFive",
							element: <Theme3SubtopicOneActivityFive />,
						},
						{
							path: "activityresult",
							element: <Theme3SubtopicOneFinalPoints />,
						},
					],
				},
				{
					path: "subtema2",
					children: [
						{
							path: "activityOne",
							element: <Theme3SubtopicTwoActivityOne />,
						},
						{
							path: "activityTwo",
							element: <Theme3SubtopicTwoActivityTwo />,
						},
						{
							path: "activityThree",
							element: <Theme3SubtopicTwoActivityThree />,
						},
						{
							path: "activityFour",
							element: <Theme3SubtopicTwoActivityFour />,
						},
						{
							path: "activityFive",
							element: <Theme3SubtopicTwoActivityFive />,
						},
						{
							path: "activityresult",
							element: <Theme3SubtopicTwoFinalPoints />,
						},
					],
				},
				{
					path: "subtema3",
					children: [
						{
							path: "activityOne",
							element: <Theme3SubtopicThreeActivityOne />,
						},
						{
							path: "activityTwo",
							element: <Theme3SubtopicThreeActivityTwo />,
						},
						{
							path: "activityThree",
							element: <Theme3SubtopicThreeActivityThree />,
						},
						{
							path: "activityFour",
							element: <Theme3SubtopicThreeActivityFour />,
						},
						{
							path: "activityresult",
							element: <Theme3SubtopicThreeFinalPoints />,
						},
					],
				},
				{
					path: "final",
					element: <SubtopicFinalTeam3 />,
				},
			],
		}
	]
}